import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: #333;
  width: 100%;
  left: 0px;
  top: 0px;
  height: 100%;
  display: flex;
  z-index: 3000;
  position: fixed;
  overflow-y: auto;

  @media (max-width: 1024px) {
  }
`;

export const Content = styled.div`
  width: 100%;
  background: #333;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  @media (max-width: 1024px) {
  }
`;

export const Header = styled.div`
  width: 100%;
  padding: 2rem;
  max-width: 60rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  h1 {
    font-size: 36px;
    color: #fff;
  }

  button {
    background: none;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 1024px) {
    padding: 15px;
    padding-bottom: 0px;

    h1 {
      font-size: 2rem;
    }
  }
`;

export const Search = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 60rem;

  input {
    background: rgba(255, 255, 255, 0.02);
    width: 100%;
    float: left;
    height: 80px;
    padding: 0 2rem;
    border: 2px solid rgba(255, 255, 255, 0.8);
    border-radius: 1rem;
    color: #fff;
    font-size: 26px;
    font-weight: 700;
  }

  button {
    background: none;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  button.close {
    margin-left: -50px;
    margin-right: 20px;
    opacity: 0.6;
  }

  button.search {
    margin-left: 20px;
  }

  @media (max-width: 1024px) {
    padding: 15px;

    input {
      height: 60px;
      font-size: 1rem;
      padding: 0 1rem;
      border-radius: 0.6rem;
    }
  }
`;

export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 2px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 1024px) {
    margin: 20px 0 0 0;
  }
`;

export const Item = styled.button`
  width: 100%;
  color: #fff;
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.5rem;
  float: left;
  cursor: pointer;

  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }

  &:nth-child(odd) {
    background: rgba(255, 255, 255, 0.02);
  }

  span {
    margin-left: 1rem;
    font-size: 22px;
  }

  @media (max-width: 1024px) {
    span {
      font-size: 1rem;
    }
  }
`;
